import { render, staticRenderFns } from "./gc-bom-bulk-update-stale-diff-banner.vue?vue&type=template&id=0afc67aa"
import script from "./gc-bom-bulk-update-stale-diff-banner.vue?vue&type=script&lang=js"
export * from "./gc-bom-bulk-update-stale-diff-banner.vue?vue&type=script&lang=js"
import style0 from "./gc-bom-bulk-update-stale-diff-banner.vue?vue&type=style&index=0&id=0afc67aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports